import * as React from 'react';

function SvgSquareHalf(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
      <path d="M21.087 1C22.144 1 23 1.856 23 2.913v18.174A1.913 1.913 0 0121.087 23H2.913A1.913 1.913 0 011 21.087V2.913C1 1.856 1.856 1 2.913 1zM11 2.913H2.913v18.174L11 21.086V2.913zm2 13.435v4.738h4.738L13 16.348zm0-6.991v4.295l7.434 7.434.653.001-.001-3.644L13 9.357zm.628-6.444H13v3.73l8.086 8.086v-4.358l-7.458-7.458zm7.459 0h-4.889l4.888 4.888.001-4.888z" />
    </svg>
  );
}

export default SvgSquareHalf;
